import React from "react";

interface PillProps {
  label: string;
  count?: number;
  active?: boolean;
  onClick?: () => void;
}

const Pill: React.FC<PillProps> = ({ label, count, active, onClick }) => (
  <button type="button" className={`ds-pill ${active ? "active" : ""}`} onClick={onClick}>
    {label}
    {typeof count === "number" && <span className="pc">{count}</span>}
  </button>
);

export default Pill;
